import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './max-price')
);

const MaxPriceLoader = props => <LoadableComponent {...props} />;

export default MaxPriceLoader;
